import {Controller} from "stimulus"
import {
    postWpRestApi,
    wpRestApiAddFieldsError,
    wpRestApiHandleInitianInputChecked
} from "./../utils/request"

import {
    removeErrorsOnFields,
    cleanInputsValues,
} from "./../utils/request"

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "input",
        "form"
    ]

    initialize() {
        // Save input initial value
        this.defaultParentSelector = ".field-group"
        wpRestApiHandleInitianInputChecked(this.$inputs)
        if ( this.data.get("fireOnInit") === "true") {
            this.submit()
        }
    }

    get $inputs() {
        let inputs = this.hasInputTargets ? this.inputTargets : [...this.element.querySelectorAll("input"), ...this.element.querySelectorAll("select"), ...this.element.querySelectorAll("textarea")]
        return inputs
    }

    /**
     * URL form processing
     * @returns {*}
     */
    get action() {
        return this.data.get("action")
    }

    get inputInvalidMessageSelector() {
        return this.data.get("inputInvalidMessageSelector")
    }

    submit(e) {
        e ? e.preventDefault() : null
        this.post()
    }

    onError(e) {

    }

    onSuccess(response) {
        removeErrorsOnFields(this.$inputs)
        cleanInputsValues(this.$inputs)
    }

    async post() {

        let data = new FormData(this.formTarget)

        const response = await postWpRestApi(this.action, data, null)

        if ( response.success) {
            this.onSuccess(response)
            return
        }

        if ( !response.success ) {

            wpRestApiAddFieldsError(response, this.$inputs, this.inputInvalidMessageSelector)

            this.onError(response)

        }



    }

}